import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';

import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-technical-error',
  imports: [MatDividerModule, MatButtonModule],
  templateUrl: './technical-error.component.html',
  styleUrl: './technical-error.component.scss',
})
export class TechnicalErrorComponent implements OnInit {
  pageLabels$!: Observable<any>;
  pageLabels: any = {};
  isBrowser = false;
  pageReady = false;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly router: Router,
    private readonly utils: UtilService,
    private readonly cms: CmsService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.cms.getContent('oas-technical-error', 'OASTechnicalError').subscribe((data) => {
      this.pageLabels = data;
      this.pageLabels.ctaLabel = this.pageLabels.ctaList[0].ctaLabel;
      this.pageLabels.ctaAriaLabel = this.pageLabels.ctaList[0].ctaAriaLabel;
      this.seoS.setSeoTags(data.seo);
      this.pageReady = true;
      this.utils.hideSpinner();
    });
  }

  async goToRedirectPage(): Promise<void> {
    await this.router.navigateByUrl(this.pageLabels.ctaList[0].ctaUrl);
  }
}
